import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ContactModal from '../ContactModal';
import './LandingSections.css';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            {/* About Section */}
            <div className="footer-section">
              <h3>Nawiri Chess House</h3>
              <p>
                Your one-stop resource for all things chess. Get trained by seasoned chess coaches,
                learn about upcoming events, and access chess gear all from one resource.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/shop">Shop</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
              </ul>
            </div>

            {/* Programs */}
            <div className="footer-section">
              <h4>Programs</h4>
              <ul>
                <li><Link to="/programs">Training Programs</Link></li>
                <li><Link to="/events">Events</Link></li>
                <li><Link to="/chess-for-schools">Chess for Schools</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-section">
              <h4>Contact</h4>
              <button
                className="footer-contact-btn"
                onClick={() => setIsModalOpen(true)}
              >
                Contact Us
              </button>
              <p style={{ marginTop: '1rem' }}>📍 Nairobi, Kenya</p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2025 Nawiri Chess House. All Rights Reserved.</p>
          </div>
        </div>
      </footer>

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Footer;
